import React, { useState, useEffect, useMemo } from "react";
import { useForm, Controller } from "react-hook-form";
import {
  Modal,
  TextField,
  Button,
  Box,
  Typography,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  CircularProgress,
} from "@mui/material";
import { orange } from "@mui/material/colors"
import Dropzone from "react-dropzone";
import _ from "lodash";
import ApiFilesService from "../../../core/api/Api.filesService";
import SwalMessage from "../_Components/SwalMessage";
import FormControlLabel from "@mui/material/FormControlLabel";
import { Radio, RadioGroup } from "@mui/material";

export const UploadFiles = (props) => {
  const showisUserAccessDownload = useMemo(() =>
    props?.basketItemId ? (props.basketItemId != 0 ? true : false) : false
    , [props]);
  const [showModal, setShowModal] = useState(false);
  const [refreshAPi, setrefreshAPi] = useState(false);
  const [files, setFiles] = useState([]);
  const [dataAllFilesBasketItem, setdataAllFilesBasketItem] = useState([]);

  const {
    handleSubmit,
    control,
    formState: { isSubmitting },
    getValues,
    setValue,
  } = useForm({
    defaultValues: {
      agentId: props?.agentId ? props.agentId : 0,
      basketItemId: props?.basketItemId ? props.basketItemId : 0,
      transactionId: props?.transationsId ? props.transationsId : 0,
      files_Type: props?.files_Type ? props.files_Type : props?.basketItemId ? (props.basketItemId != 0 ? "3" : 0) : 0,
      access: 1,
      attachments2: "",
      attachments: [],
    },
  });

  useEffect(() => {
    (async () => {
      try {
        if (showModal) {
          let obj = {
            agentId: props.agentId,
            basketItemId: props.basketItemId,
            transationsId: props.transationsId,
          };
          const AllFilesBAsketItem = await ApiFilesService.getBasketItemFile(obj);
          setdataAllFilesBasketItem(AllFilesBAsketItem);
          setrefreshAPi(false);
          setFiles([]);
        }
      } catch (error) {
      }
    })();

    return () => { };
  }, [showModal, refreshAPi]);

  let handleClose = (e) => {
    !_.isUndefined(e) && e.stopPropagation();
    setShowModal(false);
  };
  const handleisUserAccessDownload = (event, value) => {
    setValue("files_Type", value);
  };
  let removeFile = (item) => {
    files.map((item) => {
      files.splice(item, 1);
      setFiles(...files);
    });
  };
  const onSubmit = async (data) => {
    try {
      if (data.basketItemId != 0 && getValues("files_Type") == 0) {
        SwalMessage({ title: "نوع فایل انتخاب نشده است", iSsuccess: false });
        return;
      }
      if ((!data.attachments || data.attachments.length === 0) && data.attachments2 === "") {
        SwalMessage({ title: "فایلی انتخاب نشده است", iSsuccess: false });
        return;
      }
      else {
        const formData = new FormData();
        for (const [key, value] of Object.entries(data)) {
          if (key != "attachments" && key != "attachments2") {
            !_.isUndefined(value) && formData.append(key, value);
          }
        }

        data.attachments2 != "" && data.attachments.push(data.attachments2);
        let fileInfoType = [];
        data.attachments.forEach((element) => {
          formData.append("attachments", element);
          fileInfoType.push({ path: element.path, name: element.name, type: element.type });
        });
        data.fileInfoTypeC = fileInfoType;
        try {
          await ApiFilesService.saveFileInfo(data).then((rest) => {
            if (rest.succeeded && rest.data == 1) {
              let fileInformation = JSON.parse(rest.message);
              formData.delete("agentId");
              formData.delete("basketItemId");
              formData.delete("transactionId");
              formData.delete("files_Type");
              fileInformation.forEach((element, index) => {
                formData.append("fileInfo[" + index + "].Id", element.Id);
                formData.append("fileInfo[" + index + "].OrginalName", element.OrginalName);
              });

              ApiFilesService.uploadFiles(formData).then((rest2) => {
                SwalMessage({ title: rest2.message, iSsuccess: rest2.data, timer: 10000 });
                setrefreshAPi(true);
              });
            } else {
              SwalMessage({ title: rest.message, iSsuccess: rest.data, timer: 10000 });
            }
          });
        } catch (error) {
        } finally {
        }

        setValue("attachments2", "");
        setValue("attachments", []);
        setrefreshAPi(true);
        removeFile();
      }
    } catch (error) {
    }
  };
  function checked() {
    setShowModal(true);
  }

  const handleDownload = (item) => async (event) => {
    let IdSelected = getValues("agentId")
      ? getValues("agentId")
      : getValues("basketItemId") != 0
        ? getValues("basketItemId")
        : getValues("transactionId") != 0
          ? getValues("transactionId")
          : 0;
    if (IdSelected == 0) {
      SwalMessage({ title: "لطفا مجدد فایل آپلود را باز نمایید", iSsuccess: false, timer: 10000 });

      return;
    }
    let obj = {
      id: IdSelected,
      fileId: item.id,
      access: 1,
    };
    let rest = await ApiFilesService.getFile(obj).then((response) => {
      if (response.type == "text/plain") {
        let myblob = new Blob([response]);
        myblob.text().then((text) => {
          SwalMessage({ title: text, iSsuccess: false, timer: 15000 });
        });
      } else {
        const fileBlobUrl = URL.createObjectURL(new Blob([response]));
        const anchor = document.createElement("a");
        anchor.style.display = "none";
        anchor.id = item.fileName + Math.floor(Math.random() * 100);
        anchor.href = fileBlobUrl;
        anchor.download = item.fileName;
        document.body.appendChild(anchor);
        anchor.click();
      }
    });
  };
  function getFilenameFromContentDisposition(res) {
    let filename = null;
    const disposition = res.headers.get("content-disposition");
    if (disposition?.includes("attachment")) {
      const filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      const matches = filenameRegex.exec(disposition);
      if (matches?.[1]) {
        filename = matches[1].replace(/['"]/g, "");
        // Sometimes the filename comes in a URI encoded format so decode it
        filename = decodeURIComponent(filename);
        // Sometimes the filename starts with UTF-8, remove that
        filename = filename.replace(/^UTF-8/i, "").trim();
      }
    }

    return filename;
  }

  async function getFileFromLink(url, filename) {
    const fileRes = await fetch(url);
    const blob = await fileRes.blob();

    let fileName = getFilenameFromContentDisposition(fileRes);
    if (!fileName) {
      fileName = filename = "" ? url.split("/").pop() : filename;
    }
    const file = new File([blob], fileName, {
      type: blob.type,
    });

    return file;
  }
  const handlePaste = async (event) => {
    event.stopPropagation();
    event.preventDefault();
    if (event.clipboardData.files.length) {
      let fileObjectCtrlV = event.clipboardData.files[0];

      const items = (event.clipboardData || event.originalEvent.clipboardData).items;

      let blob = null;
      for (let i = 0; i < items.length; i++) {
        if (items[i].type.indexOf("image") === 0) {
          blob = items[i].getAsFile();
        }
      }

      if (blob !== null) {
        const reader = new FileReader();
        reader.onload = function (event) {
          getFileFromLink(event.target.result, fileObjectCtrlV?.name).then((result) => {
            setValue("attachments2", result);
          });
        };
        reader.readAsDataURL(blob);
      }
    }
  };
  const handleChange = (item) => (event) => {
    callApiService(item);
  };
  const handleChangeVoucher = (item) => (event) => {
    changeVoucherFileStatus(item);
  };
  async function callApiService(rowItem) {
    var rest = ApiFilesService.changeActived({ Id: rowItem.id, IsActive: !rowItem.isActive }).then((result) => {
      SwalMessage({ title: result.message, iSsuccess: result.data });
      if (result.succeeded == true) setrefreshAPi(true);
    });
  }
  async function changeVoucherFileStatus(rowItem) {
    var rest = ApiFilesService.changeVoucherFileStatus({ Id: rowItem.id, Status: rowItem.filesType == 3 ? 2 : 3 }).then(
      (result) => {
        SwalMessage({ title: result.message, iSsuccess: result.data });
        if (result.succeeded == true) setrefreshAPi(true);
      },
    );
  }
  return (
    <div className="btn btn-light " title="آپلود فایل" onClick={(e) => checked()}>
      <i className="fas  text-small fa-upload"></i>
      {props?.showText != "" && props.showText}
      {showModal && (
        <Modal
          open={showModal}
          onClose={handleClose}
          aria-labelledby="modal-title"
          aria-describedby="modal-description"
          disableScrollLock
        >
          <Box
            component="form"
            onSubmit={handleSubmit(onSubmit)}
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%,-50%)",
              p: 4,
              bgcolor: "background.paper",
              borderRadius: 1,
              boxShadow: 24,
              width: { xs: "90%", sm: "80%", md: "70%", lg: "60%" },
            }}
          >
            <Typography id="modal-title" variant="h6" component="h2">
              آپلود فایل جدید
            </Typography>
            <Box sx={{ mt: 2 }}>
              <Controller
                name="attachments"
                control={control}
                defaultValue={[]}
                render={({ field }) => (
                  <Dropzone onDrop={(acceptedFiles) => field.onChange(acceptedFiles)}
                    useFsAccessApi={false} >
                    {({ getRootProps, getInputProps }) => (
                      <Box
                        {...getRootProps()}
                        sx={{
                          border: "2px dashed gray",
                          p: 2,
                          textAlign: "center",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          gap: 2,
                          "&:hover": {
                            backgroundColor: "rgba(0,0,0,0.025)",
                            cursor: "pointer",
                            transition: "background-color 300ms"
                          }
                        }}
                      >
                        <input {...getInputProps()} />
                        <Typography>{field.value && field.value.length > 0 ? field.value[0].name : "انتخاب فایل"}</Typography>
                        {field.value && field.value.length > 0 && <Button
                          onClick={(e) => {
                            e.stopPropagation()
                            field.onChange(null)
                          }}
                          sx={{
                            scale: "0.8 !important",
                            zIndex: "10 !important"
                          }}
                          variant="outlined"
                          color="warning"
                        >
                          <i className="far fa-trash-alt" style={{ color: orange[700], fill: orange[700], stroke: orange[700] }} />
                        </Button>
                        }
                      </Box>
                    )}
                  </Dropzone>
                )}
              />
            </Box>
            {showisUserAccessDownload && (
              <>
                <Box sx={{ mt: 2 }}>
                  <Controller
                    name="attachments2"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        fullWidth
                        multiline
                        sx={{
                          ".css-n1i46s-MuiInputBase-root-MuiOutlinedInput-root": {
                            padding: "8.5px 14px 8.5px 0px !important",
                          }
                        }}
                        placeholder="Ctrl+V"
                        {...field}
                        value={field.value?.name}
                        onPaste={handlePaste}
                      />
                    )}
                  />
                </Box>
                <Box className="radio-btn-large" sx={{ mt: 2, display: "flex", alignItems: "center" }}>
                  <Controller
                    name="files_Type"
                    control={control}
                    render={({ field }) => (
                      <RadioGroup row {...field} value={field.value || "3"} onChange={handleisUserAccessDownload}>
                        <FormControlLabel value="3" className="mx-5" control={<Radio />} label="فایل واچر اپراتور" />
                        <FormControlLabel className="mx-5" value="2" control={<Radio />} label="فایل واچر کاربر" />
                      </RadioGroup>
                    )}
                  />
                </Box>
                <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
                  <Button variant="contained" color="success" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <CircularProgress size={24} />}
                    آپلود فایل
                  </Button>
                  <Button variant="contained" color="error" onClick={handleClose}>
                    بستن
                  </Button>
                </Box>
              </>
            )}
            <Box sx={{ mt: 2 }}>
              {!_.isEmpty(dataAllFilesBasketItem) ? (
                <>
                  <Typography>فایل های اپلود شده برای این آیتم</Typography>
                  <TableContainer sx={{ maxHeight: window.innerHeight * 0.4 }} component={Paper}>
                    <Table stickyHeader>
                      <TableHead>
                        <TableRow>
                          <TableCell>#</TableCell>
                          <TableCell>نوع فایل</TableCell>
                          <TableCell>دانلود</TableCell>
                          <TableCell>تاریخ ایجاد</TableCell>
                          <TableCell>وضعیت آپلود</TableCell>
                          <TableCell>وضعیت فایل</TableCell>
                          <TableCell>فایل واچر کاربر</TableCell>
                        </TableRow>
                      </TableHead>
                      <TableBody>
                        {dataAllFilesBasketItem.map((item, index) => (
                          <TableRow key={item.id}>
                            <TableCell>{item.id}</TableCell>
                            <TableCell>{item.filesTypeS}</TableCell>
                            <TableCell>
                              <Button type="button" onClick={handleDownload(item)}>
                                دانلود فایل
                              </Button>
                            </TableCell>
                            <TableCell>{item.created}</TableCell>
                            <TableCell>
                              {item.isDeleted ? (
                                <Typography color="error">عدم آپلود فایل</Typography>
                              ) : (
                                <Typography color="success">فایل موجود است</Typography>
                              )}
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={item.isActive}
                                value="item.isActive"
                                color="primary"
                                disabled={item.isDeleted}
                                onChange={handleChange(item)}
                              />
                            </TableCell>
                            <TableCell>
                              <Switch
                                checked={item.filesType !== 3}
                                value="item.isActive"
                                color="primary"
                                disabled={item.isDeleted}
                                onChange={handleChangeVoucher(item)}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                      </TableBody>
                    </Table>
                  </TableContainer>
                </>
              ) : (
                <Box sx={{ p: 2, bgcolor: "warning.light", textAlign: "center", borderRadius: 1 }}>
                  <Typography>فایلی برای این آیتم آپلود نشده است.</Typography>
                </Box>
              )}
            </Box>
            <Box sx={{ mt: 2, display: "flex", justifyContent: "space-between" }}>
              {!showisUserAccessDownload && (
                <>
                  <Button variant="contained" color="success" type="submit" disabled={isSubmitting}>
                    {isSubmitting && <CircularProgress size={24} />}
                    آپلود فایل
                  </Button>
                  <Button variant="contained" color="error" onClick={handleClose}>
                    بستن
                  </Button>
                </>
              )}
            </Box>
          </Box>
        </Modal>
      )}
    </div>
  );
};
